import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Banner, Breadcrumb, DealCard, DealsContext, HeroBanner, SanitizedHtml, Skeleton } from 'components';
import { routes } from 'router';

const DealItemSkeletons = () => {
  return (
    <>
      {[...Array(5)].map((_, index) => (
        <div className="deal-item mt-4" key={`deal-card-skeleton-${index}`}>
          <div className="h-full w-full lg:rounded-xl lg:overflow-hidden">
            <div className="image-container">
              <Skeleton type="square" size="xl" classNames="h-full w-full lg:h-[17.38rem]  lg:rounded-xl " />
            </div>
          </div>

          <div className="content-container">
            <Skeleton type="text" size="xs" classNames="w-full xl:w-[25%] lg:h-8" />
            <Skeleton type="text" size="xs" classNames="w-full xl:w-[20%] lg:h-8" />
            <Skeleton type="text" size="xs" classNames="w-full xl:w-[25%] lg:h-8" />
          </div>
        </div>
      ))}
    </>
  );
};

const DealsList = () => {
  const { loading, data: dealsData } = useContext(DealsContext);
  const { t } = useTranslation();
  const breadcrumbItems = [
    { url: routes.home.path, label: t('breadcrumb.home') },
    { url: routes.deals.path, label: t('breadcrumb.deals') }
  ];

  return (
    <>
      <HeroBanner
        title={dealsData?.data?.[0]?.heroTitle || ''}
        image={dealsData?.data?.[0]?.heroImageDesktop}
        mobileImage={dealsData?.data?.[0]?.heroImageMobile}
        loading={loading}
      />

      <div className="main-container my-20">
        <Breadcrumb breadcrumbItems={breadcrumbItems} />

        <SanitizedHtml content={dealsData?.data?.[0]?.intro} className="mb-8 mt-4" />

        <div className="pb-6 lg:pb-4 lg:mb-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 3xl:grid-cols-4 gap-4 gap-y-8">
            {loading && <DealItemSkeletons />}

            {!loading && isEmpty(dealsData?.data?.[0]?.deals) && (
              <Banner type="warning" icon={{ name: 'circle-info', style: 'fad' }} className="col-span-3">
                <span>{t('contentUnavailable')}</span>
              </Banner>
            )}

            {!loading &&
              dealsData?.data?.[0]?.deals?.map((deal, index) => <DealCard deal={deal} key={`deal-card-${index}`} />)}
          </div>
        </div>
      </div>
    </>
  );
};

export default DealsList;
